export const exportClaimsPdf = async ({ title, headers, keys, moneyKeys, rows, sections, valuesFor, filename }) => {
  const [{ jsPDF }, { autoTable }] = await Promise.all([
    import('jspdf'), import('jspdf-autotable'),
  ]);
  const document = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3' });
  const tableWidth = document.internal.pageSize.getWidth() - 20;
  const columnWeights = keys.map((key) => (
    ['accidentNarrative', 'internalNotes'].includes(key) ? 2.5 : 1
  ));
  const totalWeight = columnWeights.reduce((total, weight) => total + weight, 0);
  const columnStyles = Object.fromEntries(columnWeights.map((weight, index) => [
    index, { cellWidth: tableWidth * weight / totalWeight },
  ]));
  const grouped = rows.reduce((groups, row) => {
    (groups[row.location] ||= []).push(row);
    return groups;
  }, {});
  const money = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' });
  const formatValue = (value, index) => {
    if (value instanceof Date) return value.toLocaleDateString('en-US');
    if (typeof value === 'number' && moneyKeys.has(keys[index])) return money.format(value);
    return String(value ?? '');
  };
  let firstPage = true;
  const groups = Object.entries(grouped).sort(([a], [b]) => a.localeCompare(b));
  if (!groups.length) groups.push(['All selected locations', []]);
  groups.forEach(([branch, branchRows]) => {
    sections.forEach((section) => {
      if (!firstPage) document.addPage();
      firstPage = false;
      const records = branchRows.filter((row) => row.workflow === section.workflow);
      autoTable(document, {
        head: [headers],
        body: records.length
          ? records.map((row) => valuesFor(row).map(formatValue))
          : [[{ content: 'No claims for this section', colSpan: headers.length }]],
        margin: { top: 30, right: 10, bottom: 15, left: 10 },
        tableWidth,
        columnStyles,
        styles: { fontSize: 5, cellPadding: 1, overflow: 'linebreak', valign: 'top' },
        headStyles: { fillColor: [23, 59, 112] },
        alternateRowStyles: { fillColor: [245, 247, 251] },
        horizontalPageBreak: false,
        didDrawPage: () => {
          document.setFontSize(14);
          document.text(title, 10, 12);
          document.setFontSize(10);
          document.text(`${branch} - ${section.title}`, 10, 20);
        },
      });
    });
  });
  const pages = document.getNumberOfPages();
  for (let page = 1; page <= pages; page += 1) {
    document.setPage(page);
    document.setFontSize(9);
    document.text(`Page ${page} of ${pages}`, 10, document.internal.pageSize.getHeight() - 7);
  }
  document.save(filename);
};
